"use client";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";

import { TOAST_DURATION_MS } from "./auth-error-toasts.const";

// This file contains the different toasts that can be shown when an error occurs during the auth flow
// Right now this includes the toasts for the Google One Tap Fusion Auth, but it can be expanded to include toasts for other auth methods in the future

export const authErrorToasts = {
  wrongMethod: (signinUrl: string) => ({
    description: (
      <Text typeface="body-1-m">
        <FormattedMessage defaultMessage="This email is associated with a different login method. Please log in using another method." />
      </Text>
    ),
    variant: "destructive" as const,
    action: (
      <Button variant="outline-1" href={signinUrl}>
        Sign In
      </Button>
    ),
    duration: TOAST_DURATION_MS.wrongMethod,
  }),
  suspended: () => ({
    description: (
      <Text typeface="body-1-m">
        <FormattedMessage defaultMessage="It appears that your account is no longer active on Peerspace. If you believe this is a mistake, or if you need further assistance, please contact our Support Team." />
      </Text>
    ),
    variant: "destructive" as const,
    action: (
      <Button
        variant="outline-1"
        href="https://support.peerspace.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage defaultMessage="Contact" />
      </Button>
    ),
    duration: TOAST_DURATION_MS.suspended,
  }),
  generic: () => ({
    description: (
      <Text typeface="body-1-m">
        <FormattedMessage defaultMessage="Something went wrong, please try again. If the problem persists please refresh." />
      </Text>
    ),
    variant: "destructive" as const,
  }),
};

export type AuthErrorToastType = keyof typeof authErrorToasts;
